import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import SlideoutMenu from 'components/AppMenu/SlideoutMenu';
import LogoutFrame from 'components/@common/LogoutFrame';
import SWNotifier from 'components/SWNotifier';
import LoadingScreen from 'components/@common/LoadingScreen/LoadingScreen';
import maybe from './components/@common/enhancers/maybe';
import OnboardingTour from 'containers/Tours/modules/Onboarding';
import { hasClickAwayOnly } from 'state/modules/user/selectors/user-selectors';

const MaybeLogout: any = maybe(LogoutFrame);

const Main = (props: any) => {
  const classes = useStyles();

  const ui = useSelector(({ ui }: any) => ui);
  const isLoadingContent = useSelector(
    ({ ui, entity }: any) => ui.isLoadingContent || entity.loading
  );
  const user = useSelector(({ user }: any) => user);

  const userOnboardingTour = user.settings?.tours?.find(x => x.name === 'onboarding');
  const shouldDoOnboardingTour = !!userOnboardingTour?.steps?.length;
  const isClickAwayOnly = useSelector(state => hasClickAwayOnly(state));
  const hasLoggedOut: any = user.isLoggedOut;
  const slideoutSelectedSubmenu = ui.selectedSubmenu;

  const SWNotifier1 = SWNotifier as any;

  return (
    <div className={classes.wrapperContainer}>
      <SWNotifier1>
        <LoadingScreen loading={isLoadingContent} />
        {shouldDoOnboardingTour && !isClickAwayOnly && (
          <OnboardingTour open={shouldDoOnboardingTour} />
        )}
        <SlideoutMenu isClickAwayOnly={isClickAwayOnly} selectedSubmenu={slideoutSelectedSubmenu}>
          {props.children}
          <MaybeLogout shouldRender={hasLoggedOut} />
        </SlideoutMenu>
      </SWNotifier1>
    </div>
  );
};

const useStyles = makeStyles(() => {
  return {
    wrapperContainer: {
      width: '100%',
      height: '100%',
      position: 'relative',
      overflowY: 'hidden',
      minHeight: '100%'
    }
  };
});

export default Main;
